<script>
import { shallowRef, watch } from 'vue';
import * as THREE from 'three';
import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/* IMPORT MODEL SHADERS */
import vertex from '../../shaders/vertex.glsl'
import fragment from '../../shaders/fragment.glsl'
import atmosphereVertex from '../../shaders/atmosphereVertex.glsl'
import atmosphereFragment from '../../shaders/atmosphereFragment.glsl'

let notMobile = window.matchMedia("(min-width: 1020px)");

gsap.registerPlugin(ScrollTrigger);

    export default {
        props: [ "data", "chapters", "markers" ],
        data(){
            return {
                
            }
        },
        mounted() {
            // if( notMobile.matches ) {
                const markers = JSON.parse(this.markers);

                const canvas = document.querySelector("canvas");
                const globe = document.querySelector("#globe");

                const scene = new THREE.Scene();
                const camera = new THREE.PerspectiveCamera( 75, (window.innerWidth / 2) / window.innerHeight, 0.1, 1000 );

                //Set the camera position
                camera.position.set(0, 0, 12);
                camera.lookAt(0, 0, 0);

                const renderer = new THREE.WebGLRenderer({
                    alpha: true,
                    // clearAlpha: 0,
                    antialias: true
                });
                // renderer.sortObjects = false;
                renderer.setSize( window.innerWidth, window.innerHeight );
                renderer.setPixelRatio(devicePixelRatio); //Stop jagged lines

                let labelRenderer = new CSS2DRenderer();
                labelRenderer.setSize( window.innerWidth / 2, window.innerHeight );
                labelRenderer.domElement.classList.add('labels-wrapper');
                globe.appendChild( labelRenderer.domElement );
                let DOMelement = document.querySelector("#globe");
                DOMelement.appendChild( renderer.domElement );


                const sphere = new THREE.Mesh(
                    new THREE.SphereGeometry( 5, 50, 50 ),
                    new THREE.ShaderMaterial({
                        vertexShader: vertex,
                        fragmentShader: fragment,
                        blending: THREE.AdditiveBlending,
                        side: THREE.BackSide,
                        uniforms: {
                            globeTexture: {
                                value: new THREE.TextureLoader().load('../../../images/map-texture2.png'),
                            },
                            color1: {
                                value: new THREE.Color("blue")
                            },
                            color2: {
                                value: new THREE.Color("purple")
                            }
                        }
                    })
                );

                let texture = new THREE.TextureLoader().load('../../../images/map-texture.jpg');

                const mapLayer = new THREE.Mesh(
                    new THREE.SphereGeometry(5,50,50),
                    new THREE.MeshBasicMaterial({
                        map: texture,
                        transparent: true,
                        opacity: 1,
                        // side: THREE.FrontSide,
                        // blending: THREE.AdditiveBlending,
                    })
                )

                const atmosphere = new THREE.Mesh(
                    new THREE.SphereGeometry(5,50,50),
                    new THREE.ShaderMaterial({
                        vertexShader: atmosphereVertex,
                        fragmentShader: atmosphereFragment,
                        blending: THREE.AdditiveBlending,
                        side: THREE.BackSide,
                        transparent: true,
                    })
                );

                atmosphere.scale.set(1.1, 1.1, 1.1);
                // mapLayer.scale.set(1.02, 1.02, 1.02);

                mapLayer.rotation.y = -Math.PI / 2; //Needs this to set the map texture into Greewich Meantime

                const group = new THREE.Group();
                group.add(mapLayer);

                scene.add( group );
                scene.add( sphere );
                scene.add( atmosphere );
                
                const mouse = {
                    x: undefined,
                    y: undefined
                }

                addEventListener("mousemove", function(event) {
                    mouse.x = (event.clientX / innerWidth * 2 - 1)
                    mouse.y = -(event.clientY / innerHeight * 2 + 1)
                });

                function createMarker(lat, lng, name, title) {
                    const point = new THREE.Mesh(
                        new THREE.BoxGeometry(0.2, 0.2, 0.5),
                        new THREE.MeshBasicMaterial({
                            color: "#aaaae4",
                            transparent: true,
                            opacity: 0.9,
                        })
                    );

                    const latitude = (lat / 180) * Math.PI;
                    const longitude = (lng / 180) * Math.PI;
                    const radius = 5;

                    const x = radius * Math.cos(latitude) * Math.sin(longitude);
                    const y = radius * Math.sin(latitude);
                    const z = radius * Math.cos(latitude) * Math.cos(longitude);

                    point.position.x = x;
                    point.position.y = y;
                    point.position.z = z;
                    point.lookAt(0,0,0);

                    point.name = name;

                    group.add(point);

                    //Position the label onto the point
                    let labelWrapper = document.createElement("div");
                    let labelElement = document.createElement("p");
                    labelElement.className = "chapter-label";
                    labelElement.textContent = title;

                    labelWrapper.appendChild(labelElement);
                    
                    const label = new CSS2DObject( labelWrapper );
                    label.position.set( 0, 0, 0 );
                    label.center.set( 0.5, 0.5 );
                    point.add(label);
                    // label.layers.set( 0 );
                }

                function moveToMarker(lat, lng, name) {
                    const latitude = (lat / 180) * Math.PI;
                    const longitude = (lng / 180) * Math.PI;
                    const radius = 5;

                    const x = radius * Math.cos(latitude) * Math.sin(longitude);
                    const y = radius * Math.sin(latitude);
                    const z = radius * Math.cos(latitude) * Math.cos(longitude);

                    let object = group.children.filter((mesh) => {
                        return mesh.name === name;
                    });
                    
                    if( object != null ) {
                        object[0].scale.z = 3;

                        // group.rotation.set(
                        //     0,
                        //     THREE.MathUtils.degToRad( -lng ),
                        //     0,
                        //     'ZYX'
                        // );

                        gsap.to(group.rotation, {
                            z: 0,
                            y: THREE.MathUtils.degToRad( -lng ),
                            x: 0,
                            duration: 2
                        })
                    }
                }

                let raycast = new THREE.Raycaster();

                markers.forEach((marker) => {
                    createMarker(marker.latitude, marker.longitude, marker.handle, marker.name)
                })

                const links = document.querySelectorAll(".map-link");
                links.forEach((link) => {
                    link.addEventListener("mouseover", function(e) {
                        group.children.forEach((mesh) => {
                            mesh.scale.z = 1;
                        });

                        moveToMarker(this.dataset.lat, this.dataset.lng, this.dataset.handle);
                    })
                });

                //Update the scene size on screen resize
                // window.addEventListener( "resize", (event) => {
                //     camera.aspect = innerWidth/innerHeight;
                //     camera.updateProjectionMatrix( );
                //     renderer.setSize( innerWidth, innerHeight );
                //         composer.setSize( innerWidth, innerHeight );
                // });

                //Global animate function
                function animate() {
                    group.rotation.y = group.rotation.y + 0.0008;

                    //Hide labels if they intersect with the globe
                    group.children.forEach((item) => {
                        if( item.children != null && item.children.length > 0 ) {
                            let thisLabel = item.children[0];
                            // console.log(thisLabel);
                            thisLabel.getWorldPosition(raycast.ray.origin);
                            let rd = camera.position.clone().sub(raycast.ray.origin).normalize();
                            raycast.ray.direction.set(rd.x,rd.y,rd.z);
                            let hits = raycast.intersectObjects([sphere]);

                            if (hits.length > 0 ) { 
                                gsap.to(thisLabel.element, {
                                    autoAlpha: 0,
                                    duration: 0.2
                                }) 
                            } else {
                                gsap.to(thisLabel.element, {
                                    autoAlpha: 1,
                                    duration: 0.2
                                }) 
                            }
                        }
                    })

                    renderer.setSize( window.innerWidth, window.innerHeight );

                    renderer.render( scene, camera );
                    labelRenderer.render( scene, camera );
                }
                renderer.setAnimationLoop( animate );
            }
    //    }
    }
</script>

<template>
    <section class="chapters-map brand-background">
        <div class="container">
            <div class="chapter-links">
                <h2 v-if="data.title != null" class="font-black fs-5 fadeInLeft">{{ data.title }}</h2>
                <p v-if="data.description != null && data.description.length > 0" class="fadeInLeft">{{ data.description }}</p>
                <div class="btn-list">
                    <a :href="chapter.url" v-for="chapter, index in chapters" class="fadeInLeft map-link" :data-id="chapter.id" :data-lat="chapter.latitude" :data-lng="chapter.longitude" :data-handle="chapter.handle">
                        {{ chapter.name }}
                        <div class="btn-icon">
                            <svg><use href="#arrow"></use></svg>
                        </div>
                    </a>
                </div>
                <a v-if="data.link != null" :href="data.link" class="btn btn-secondary fadeInLeft">
                    <span v-if="data.linkTitle != null">{{  data.linkTitle }}</span>
                    <div class="btn-icon">
                        <svg><use href="#arrow"></use></svg>
                    </div>
                </a>
            </div>
            <div id="globe"></div>
        </div>
    </section>
</template>